(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2119],{

/***/ 29873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ userContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

var userContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    user: null,
    setUser: function() {
        return null;
    },
    loggedIn: false,
    setLoggedIn: function() {
        return null;
    },
    setLoginModalState: function(state) {
        return state;
    },
    loginModalState: false,
    openLoginModal: function() {
        return null;
    },
    logout: function() {
        return null;
    },
    showAccountRecoverModal: function(state) {
        return state;
    },
    accountRecoverModalState: false
});



/***/ }),

/***/ 92119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth; },
  "D": function() { return /* binding */ setAppCookies; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./components/auth/auth.context.ts
var auth_context = __webpack_require__(29873);
// EXTERNAL MODULE: ./components/login-popup/index.tsx + 12 modules
var login_popup = __webpack_require__(6218);
// EXTERNAL MODULE: ../node_modules/nookies/dist/index.js
var dist = __webpack_require__(15798);
// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/getOwnProfileData.js
var getOwnProfileData = __webpack_require__(17023);
// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/postLogout.js
var postLogout = __webpack_require__(92669);
// EXTERNAL MODULE: ./helpers/neogateway.ts
var neogateway = __webpack_require__(23750);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./enums/amplitude.ts
var amplitude = __webpack_require__(8719);
// EXTERNAL MODULE: ./helpers/analytics.ts + 3 modules
var analytics = __webpack_require__(5901);
;// CONCATENATED MODULE: ./helpers/clean-url.ts
var clearQsFromUrl = function(url) {
    var qsStartIndex = url.indexOf("?");
    return qsStartIndex > -1 ? url.substring(0, url.indexOf("?")) : url;
};

// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(93434);
// EXTERNAL MODULE: ./components/dialog/dialog.tsx
var dialog = __webpack_require__(92059);
// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/postAccountRestore.js
var postAccountRestore = __webpack_require__(6377);
;// CONCATENATED MODULE: ./components/account-recover-modal/index.tsx







var DialogButtonsType;
(function(DialogButtonsType) {
    DialogButtonsType["confirm"] = "confirm";
    DialogButtonsType["cancel"] = "cancel";
})(DialogButtonsType || (DialogButtonsType = {}));
var AccountRecoverModal = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useContext)(auth_context/* userContext */.x), showAccountRecoverModal = ref.showAccountRecoverModal, logout = ref.logout;
    var dialogData = {
        displaymode: "custom",
        data: {
            id: 0
        },
        head: {
            text: t("Account_reactivation_title")
        },
        warning: false,
        body: {
            text: t("account_reactivation_message")
        },
        buttons: [
            {
                label: t("confirm"),
                styles: {
                    color: "#8d00f5",
                    backgroundColor: "white",
                    border: "1px solid #8d00f5",
                    fontSize: "0.85em",
                    padding: "0.75em 2em"
                },
                type: DialogButtonsType.confirm
            },
            {
                label: t("Cancel"),
                styles: {
                    color: "white",
                    backgroundColor: "#8d00f5",
                    fontSize: "0.9em",
                    padding: "0.8em 2em"
                },
                type: DialogButtonsType.cancel
            }
        ]
    };
    var handleOnDialogClick = function(param) {
        var type = param.type;
        if (type === DialogButtonsType.cancel) {
            showAccountRecoverModal(false);
            logout();
        } else {
            neogateway/* gateway.callEndpoint */.Y0.callEndpoint(postAccountRestore/* default */.Z, {}).then(function() {
                window.location.reload();
                showAccountRecoverModal(false);
            }).catch(function() {
                console.log("error");
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* DialogComponent */.a, {
        data: dialogData,
        onButtonClick: handleOnDialogClick
    });
};
/* harmony default export */ var account_recover_modal = (AccountRecoverModal);

// EXTERNAL MODULE: ./helpers/cookies.ts
var cookies = __webpack_require__(25863);
// EXTERNAL MODULE: ./enums/cookie-names.constants.ts
var cookie_names_constants = __webpack_require__(2978);
;// CONCATENATED MODULE: ./components/auth/index.tsx



















var setAppCookies = function(name, value) {
    (0,dist.setCookie)(null, name, value, {
        maxAge: 30 * 24 * 60 * 60 * 60,
        domain: ".angha.me",
        path: "/"
    });
    (0,dist.setCookie)(null, name, value, {
        maxAge: 30 * 24 * 60 * 60 * 60,
        domain: ".anghami.com",
        path: "/"
    });
};
var withAuth = function(WrappedComponent) {
    return function(props) {
        var ref;
        var isLoggedIn = false;
        if ((ref = props.userProfile) === null || ref === void 0 ? void 0 : ref.id) {
            isLoggedIn = true;
        } else {
            isLoggedIn = false;
        }
        var ref1 = (0,react.useState)(false), showLoginModal = ref1[0], setShowLoginModal = ref1[1];
        var ref2 = (0,react.useState)(false), showAccountRecoverModal = ref2[0], setShowAccountRecoverModal = ref2[1];
        var ref3 = (0,react.useState)(isLoggedIn), loggedIn = ref3[0], setLoggedIn = ref3[1];
        var ref4 = (0,react.useState)(props.userProfile), user = ref4[0], setUser = ref4[1];
        var router = (0,next_router.useRouter)();
        (0,react.useEffect)(function() {
            // retrying to auth in the client if it failed in the server
            if (neogateway/* gateway */.Y0 && !loggedIn && "object" !== "undefined") {
                neogateway/* gateway.callEndpoint */.Y0.callEndpoint(getOwnProfileData/* default */.Z).then(function(response) {
                    var user = response.data;
                    if (user === null || user === void 0 ? void 0 : user.id) {
                        setUser(user);
                        setLoggedIn(true);
                    }
                });
            }
            var shouldRecover = Boolean(cookies/* default.getCookie */.Z.getCookie("should_recover"));
            setShowAccountRecoverModal(shouldRecover);
        }, [
            props.sss,
            props.SID
        ]);
        var handleOnAuth = function(authResponse) {
            var authenticate = authResponse.authenticate;
            setUser((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, authenticate), {
                // Append missing data from the auth response
                country: authenticate.usercountry,
                image: authenticate.picture
            }));
            setAppCookies("loggedIn", true);
            setAppCookies("sss", authenticate.sss);
            setAppCookies("appsidsave", authenticate.socketsessionid);
            setAppCookies("firstauth", true);
            setLoggedIn(true);
            setShowLoginModal(false);
            setAppCookies("should_recover", "");
            if (authenticate.should_recover) {
                setAppCookies("should_recover", true);
                setShowAccountRecoverModal(true);
                return;
            }
            // to force the current page to re-call get initial props that used to be called in the server
            // https://github.com/vercel/next.js/issues/1982#issuecomment-301892234
            router.push(router.asPath, "");
            window.location.href = String(window.location.href);
        };
        // eslint-disable-next-line
        var auth = {
            loggedIn: loggedIn,
            setLoggedIn: setLoggedIn,
            user: user,
            setUser: setUser,
            setLoginModalState: setShowLoginModal,
            loginModalState: showLoginModal,
            openLoginModal: function() {
                setShowLoginModal(true);
            },
            logout: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                var cookie;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cookie = (0,dist.parseCookies)(null);
                            Object.keys(cookie).forEach(function(cookieKey) {
                                // Keep the cookie consent preference so the banner choice survives logout
                                if (cookieKey === cookie_names_constants/* COOKIE_CONSENT_NAME */.Z) {
                                    return;
                                }
                                (0,dist.destroyCookie)(null, cookieKey);
                            });
                            setLoggedIn(false);
                            setUser(null);
                            setAppCookies("loggedIn", false);
                            setAppCookies("should_recover", "");
                            (0,analytics/* default */.ZP)(amplitude/* AmplitudeEvents.signOut */.X.signOut, {});
                            window.localStorage.removeItem("user");
                            return [
                                4,
                                neogateway/* gateway.callEndpoint */.Y0.callEndpoint(postLogout/* default */.Z, {
                                    output: "jsonhp"
                                })
                            ];
                        case 1:
                            _state.sent();
                            // to force the current page to re-call get initial props that used to be called in the server
                            // https://github.com/vercel/next.js/issues/1982#issuecomment-301892234
                            router.push(router.asPath, "");
                            window.location.href = clearQsFromUrl(String(window.location.href));
                            return [
                                2
                            ];
                    }
                });
            }),
            accountRecoverModalState: showAccountRecoverModal,
            showAccountRecoverModal: function(state) {
                setShowAccountRecoverModal(state);
                if (!state) {
                    setAppCookies("should_recover", "");
                    (0,dist.destroyCookie)(null, "should_recover");
                }
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(auth_context/* userContext.Provider */.x.Provider, {
            value: auth,
            children: [
                showLoginModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(login_popup/* default */.ZP, {
                    params: router === null || router === void 0 ? void 0 : router.query,
                    onClosePopUp: function() {
                        setShowLoginModal(false);
                    },
                    onAuth: handleOnAuth
                }),
                showAccountRecoverModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(account_recover_modal, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, props))
            ]
        });
    };
};
/* harmony default export */ var auth = (withAuth);


/***/ }),

/***/ 6218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m3": function() { return /* binding */ Login; },
  "ZP": function() { return /* binding */ login_popup; }
});

// UNUSED EXPORTS: LoginPopup

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(93434);
// EXTERNAL MODULE: ./env/environment.js
var environment = __webpack_require__(19142);
// EXTERNAL MODULE: ./components/login-popup/styles.module.scss
var styles_module = __webpack_require__(75359);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/loadjs/dist/loadjs.umd.js
var loadjs_umd = __webpack_require__(96051);
var loadjs_umd_default = /*#__PURE__*/__webpack_require__.n(loadjs_umd);
;// CONCATENATED MODULE: ./helpers/SDKs-loader.ts




var getSDKFromWindow = function(varName) {
    return window[varName];
};
// ============= Google SDK =============
var parseGoogleSDKResponse = function(googleUser) {
    return {
        email: googleUser.getBasicProfile().getEmail(),
        token: googleUser.getAuthResponse().access_token
    };
};
var loadGoogleSDK = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    if (false) {}
                    // check if already loaded
                    var googleSDK = getSDKFromWindow("gapi");
                    if (googleSDK) {
                        resolve();
                        return;
                    }
                    loadjs_umd_default()(environment.environment.google_sdk_url, {
                        numRetries: 2,
                        success: function() {
                            getSDKFromWindow("gapi").load("auth2", function() {
                                getSDKFromWindow("gapi").auth2.init({
                                    client_id: environment.environment.google_client_id,
                                    scope: "email profile openid",
                                    prompt: "select_account",
                                    cookiepolicy: "single_host_origin",
                                    response_type: "token",
                                    redirect_uri: "https://play.anghami.com/login"
                                }).then(resolve).catch(reject);
                            });
                        },
                        error: reject
                    });
                })
            ];
        });
    });
    return function loadGoogleSDK() {
        return _ref.apply(this, arguments);
    };
}();
var handleGoogleLogin = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    if (false) {}
                    var googleAuth = getSDKFromWindow("gapi").auth2.getAuthInstance();
                    var isLoggedIn = googleAuth.isSignedIn.get();
                    if (isLoggedIn) {
                        googleAuth.signOut();
                    }
                    googleAuth.signIn().then(function(googleUser) {
                        var parsedResponse = parseGoogleSDKResponse(googleUser);
                        resolve(parsedResponse);
                    }).catch(function(error) {
                        reject(error);
                    });
                })
            ];
        });
    });
    return function handleGoogleLogin() {
        return _ref.apply(this, arguments);
    };
}();
// ============= Facebook SDK =============
var parseFacebookSDKResponse = function(response) {
    return {
        userID: response.authResponse.userID,
        accessToken: response.authResponse.accessToken
    };
};
var loadFacebookSDK = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    if (false) {}
                    // check if already loaded
                    var facebookSDK = getSDKFromWindow("FB");
                    if (facebookSDK) {
                        resolve();
                        return;
                    }
                    loadjs_umd_default()(environment.environment.facebook_sdk_url, {
                        numRetries: 2,
                        success: function() {
                            getSDKFromWindow("FB").init({
                                appId: environment.environment.facebook_app_id,
                                status: true,
                                version: "v2.8",
                                xfbml: false
                            });
                            resolve();
                        },
                        error: reject
                    });
                })
            ];
        });
    });
    return function loadFacebookSDK() {
        return _ref.apply(this, arguments);
    };
}();
var handleFacebookLogin = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    if (false) {}
                    getSDKFromWindow("FB").getLoginStatus(function(response) {
                        if (response.status === "connected") {
                            getSDKFromWindow("FB").logout();
                        }
                        getSDKFromWindow("FB").login(function(response) {
                            if (response.status === "connected") {
                                var parsedResponse = parseFacebookSDKResponse(response);
                                resolve(parsedResponse);
                            } else {
                                reject(response);
                            }
                        }, {
                            scope: "public_profile,email,user_friends",
                            return_scopes: true
                        });
                    });
                })
            ];
        });
    });
    return function handleFacebookLogin() {
        return _ref.apply(this, arguments);
    };
}();
// ============= Apple SDK =============
var loadAppleSDK = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    if (false) {}
                    // check if already loaded
                    var apple = getSDKFromWindow("AppleID");
                    if (apple) {
                        resolve();
                        return;
                    }
                    loadjs_umd_default()(environment.environment.apple_sdk_url, {
                        numRetries: 2,
                        success: resolve,
                        error: reject
                    });
                })
            ];
        });
    });
    return function loadAppleSDK() {
        return _ref.apply(this, arguments);
    };
}();
var handleAppleLogin = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    if (false) {}
                    getSDKFromWindow("AppleID").auth.init({
                        clientId: environment.environment.apple_client_id,
                        redirectURI: "".concat(window.location.origin, "/applesignin-redirect"),
                        scope: "name email",
                        usePopup: true
                    });
                    document.addEventListener("AppleIDSignInOnSuccess", function(data) {
                        resolve(data);
                    });
                    // Listen for authorization failures
                    document.addEventListener("AppleIDSignInOnFailure", function(error) {
                        reject(error);
                    });
                    return getSDKFromWindow("AppleID").auth.signIn().then(function(res) {
                        resolve(res);
                    }).catch(function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
    return function handleAppleLogin() {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/authentication.js
var authentication = __webpack_require__(14673);
// EXTERNAL MODULE: ./helpers/neogateway.ts
var neogateway = __webpack_require__(23750);
;// CONCATENATED MODULE: ./helpers/authenticate.ts




var doAuthentication = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(type, user) {
        var body;
        return (0,tslib_es6.__generator)(this, function(_state) {
            body = {
                m: type
            };
            switch(type){
                case "gop":
                    body.u = user.email;
                    body.p = user.token;
                    break;
                case "fb":
                    body.fid = user.userID;
                    body.ftk = user.accessToken;
                    break;
                case "an":
                    body.u = user.email || user.username;
                    body.p = encodeURIComponent(user.password);
                    break;
                case "lc":
                    body.u = user.userid;
                    body.p = user.code;
                    body.tv = true;
                    body._magic = true;
                    break;
                case "ap":
                    body.identitytoken = user.identitytoken;
                    body.authorizationcode = user.authorizationcode;
                    break;
                default:
                    break;
            }
            return [
                2,
                neogateway/* gateway.callEndpoint */.Y0.callEndpoint(authentication/* authenticate */.YR, body)
            ];
        });
    });
    return function doAuthentication(type, user) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./components/RingLoading/styles.module.scss
var RingLoading_styles_module = __webpack_require__(56687);
var RingLoading_styles_module_default = /*#__PURE__*/__webpack_require__.n(RingLoading_styles_module);
;// CONCATENATED MODULE: ./components/RingLoading/index.tsx




function RingLoading(param) {
    var _isBlack = param.isBlack, isBlack = _isBlack === void 0 ? false : _isBlack;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((RingLoading_styles_module_default()).RingLoading, " ").concat(isBlack && (RingLoading_styles_module_default())["RingLoading-black"]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
}
RingLoading.propTypes = {
    isBlack: (prop_types_default()).bool
};

// EXTERNAL MODULE: ./components/LoginButtons/GenericButton/styles.module.scss
var GenericButton_styles_module = __webpack_require__(83066);
var GenericButton_styles_module_default = /*#__PURE__*/__webpack_require__.n(GenericButton_styles_module);
;// CONCATENATED MODULE: ./components/LoginButtons/GenericButton/index.tsx






function GenericButton(param) {
    var icon = param.icon, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _className = param.className, className = _className === void 0 ? "" : _className, _id = param.id, id = _id === void 0 ? "" : _id, onClick = param.onClick, children = param.children;
    var renderedIcon = null;
    switch(icon){
        case undefined:
            break;
        case "fb":
            renderedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat(environment.environment.new_web_cdn_url, "/web/facebook.svg"),
                alt: "facebook logo"
            });
            break;
        case "google":
            renderedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat(environment.environment.new_web_cdn_url, "/web/google.svg"),
                alt: "google logo"
            });
            break;
        case "phone":
            renderedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat(environment.environment.new_web_cdn_url, "/web/assets/icons/all/mobile.svg"),
                alt: "phone logo"
            });
            break;
        case "apple":
            renderedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat(environment.environment.new_web_cdn_url, "/web/assets/icons/all/apple.svg"),
                alt: "apple logo"
            });
            break;
        case "anghami":
            renderedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat(environment.environment.images_cdn_url, "/anghami-logo-white-notext.svg"),
                alt: "anghami logo"
            });
            break;
        default:
            renderedIcon = "notfound";
    }
    if (isLoading) {
        renderedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(RingLoading, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: "".concat((GenericButton_styles_module_default()).GenericButton, " ").concat(className),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (GenericButton_styles_module_default())["GenericButton-icon"],
                children: renderedIcon
            }),
            children
        ]
    });
}
GenericButton.propTypes = {
    className: (prop_types_default()).string,
    icon: (prop_types_default()).string,
    onClick: (prop_types_default()).func,
    children: (prop_types_default()).any,
    isLoading: (prop_types_default()).bool,
    id: (prop_types_default()).string
};

// EXTERNAL MODULE: ./components/LoginButtons/GoogleLogin/styles.module.scss
var GoogleLogin_styles_module = __webpack_require__(43084);
var GoogleLogin_styles_module_default = /*#__PURE__*/__webpack_require__.n(GoogleLogin_styles_module);
// EXTERNAL MODULE: ../node_modules/@anghami/neoanalytics/src/enums/events.ts
var events = __webpack_require__(64408);
// EXTERNAL MODULE: ./helpers/analytics.ts + 3 modules
var analytics = __webpack_require__(5901);
;// CONCATENATED MODULE: ./components/LoginButtons/GoogleLogin/index.tsx










function GoogleLogin(param) {
    var _onSuccess = param.onSuccess, onSuccess = _onSuccess === void 0 ? function(res) {
        return res;
    } : _onSuccess, _onError = param.onError, onError = _onError === void 0 ? function(error) {
        return error;
    } : _onError;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), sdkLoading = ref1[0], setSDKLoading = ref1[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    (0,react.useEffect)(function() {
        // Toggle the loading indicator while the SDK is loading
        // Only appears if the SDK is not cached in the browser
        setSDKLoading(true);
        loadGoogleSDK().then(function() {
            setSDKLoading(false);
        }).catch(function(error) {
            onError(error);
        });
    }, []);
    var handleButtonClick = function() {
        setLoading(true);
        handleGoogleLogin().then(function(res) {
            doAuthentication("gop", res).then(function(param) {
                var _$res = param.data;
                setLoading(false);
                onSuccess(_$res);
                (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loggedInWithgoogle */.X.loggedInWithgoogle, {});
                (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loginSuccessful */.X.loginSuccessful, {
                    method: "google"
                });
            }).catch(function(error) {
                setLoading(false);
                onError(error);
                (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loginError */.X.loginError, {
                    method: "google"
                });
            });
        }).catch(function(error) {
            setLoading(false);
            onError(error);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (GoogleLogin_styles_module_default()).GoogleLogin,
        id: "google-root",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
            icon: "google",
            isLoading: loading,
            className: "".concat((GoogleLogin_styles_module_default())["GoogleLogin-btn"], " ").concat(sdkLoading && (GoogleLogin_styles_module_default())["GoogleLogin-btn-loading"]),
            onClick: function() {
                if (sdkLoading) {
                    return;
                }
                (0,analytics/* default */.ZP)(events/* AmplitudeEvents.tapGoogleLogin */.X.tapGoogleLogin, {});
                handleButtonClick();
            },
            children: t("Continue with Google")
        })
    });
}
GoogleLogin.propTypes = {
    onSuccess: (prop_types_default()).func,
    onError: (prop_types_default()).func
};

// EXTERNAL MODULE: ./components/LoginButtons/FacebookLogin/styles.module.scss
var FacebookLogin_styles_module = __webpack_require__(71564);
var FacebookLogin_styles_module_default = /*#__PURE__*/__webpack_require__.n(FacebookLogin_styles_module);
;// CONCATENATED MODULE: ./components/LoginButtons/FacebookLogin/index.tsx










function FacebookLogin(param) {
    var _onSuccess = param.onSuccess, onSuccess = _onSuccess === void 0 ? function(res) {
        return res;
    } : _onSuccess, _onError = param.onError, onError = _onError === void 0 ? function(error) {
        return error;
    } : _onError;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    var handleButtonClick = function() {
        setLoading(true);
        loadFacebookSDK().then(function() {
            handleFacebookLogin().then(function(res) {
                doAuthentication("fb", res).then(function(param) {
                    var _$res = param.data;
                    setLoading(false);
                    onSuccess(_$res);
                    (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loggedInWithfacebook */.X.loggedInWithfacebook, {});
                    (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loginSuccessful */.X.loginSuccessful, {
                        method: "facebook"
                    });
                }).catch(function(error) {
                    setLoading(false);
                    onError(error);
                    (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loginError */.X.loginError, {
                        method: "facebook"
                    });
                });
            }).catch(function(error) {
                setLoading(false);
                onError(error);
            });
        }).catch(function() {
            setLoading(false);
            onError(null);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (FacebookLogin_styles_module_default()).FacebookLogin,
        id: "fb-root",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
            icon: "fb",
            isLoading: loading,
            className: (FacebookLogin_styles_module_default())["FacebookLogin-btn"],
            onClick: function() {
                (0,analytics/* default */.ZP)(events/* AmplitudeEvents.tapFacebookLogin */.X.tapFacebookLogin, {});
                handleButtonClick();
            },
            children: t("Continue with Facebook")
        })
    });
}
FacebookLogin.propTypes = {
    onSuccess: (prop_types_default()).func,
    onError: (prop_types_default()).func
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/postMsisdnAuthenticate.js
var postMsisdnAuthenticate = __webpack_require__(71349);
// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/postMsisdnLogin.js
var postMsisdnLogin = __webpack_require__(88204);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./components/otpinput/otpinput.module.scss
var otpinput_module = __webpack_require__(8199);
var otpinput_module_default = /*#__PURE__*/__webpack_require__.n(otpinput_module);
;// CONCATENATED MODULE: ./components/otpinput/index.tsx







var Keys;
(function(Keys) {
    Keys["Backspace"] = "Backspace";
    Keys[Keys["zero"] = 0] = "zero";
    Keys[Keys["nine"] = 9] = "nine";
})(Keys || (Keys = {}));
var OTPInput = function(param) {
    var onSubmit = param.onSubmit;
    var ref = (0,react.useState)({
        0: "",
        1: "",
        2: "",
        3: ""
    }), otpValue = ref[0], setOtpValue = ref[1];
    var handleOnInputPress = function(e) {
        var target = e.target, key = e.key;
        if (e.key === Keys.Backspace) {
            if (target.previousSibling) {
                target.previousSibling.focus();
            }
            setOtpValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otpValue), (0,_define_property/* default */.Z)({}, target.dataset.index, "")));
        } else if (key >= Keys.zero || key <= Keys.nine) {
            var newOTPValue = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otpValue), (0,_define_property/* default */.Z)({}, target.dataset.index, key));
            setOtpValue(newOTPValue);
            if (target.nextSibling) {
                target.nextSibling.focus();
            } else {
                target.blur();
                onSubmit(Object.values(newOTPValue).join(""));
            }
        }
    };
    var handleOnChange = function() {
        return null;
    };
    var handleOnFocus = function(e) {
        e.target.select();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (otpinput_module_default()).OTPInput,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                autoFocus: true,
                maxLength: 1,
                "data-index": 0,
                type: "tel",
                value: otpValue[0],
                onFocus: handleOnFocus,
                onChange: handleOnChange,
                onKeyUp: handleOnInputPress
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                maxLength: 1,
                type: "tel",
                "data-index": 1,
                value: otpValue[1],
                onFocus: handleOnFocus,
                onChange: handleOnChange,
                onKeyUp: handleOnInputPress
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                maxLength: 1,
                type: "tel",
                "data-index": 2,
                value: otpValue[2],
                onFocus: handleOnFocus,
                onChange: handleOnChange,
                onKeyUp: handleOnInputPress
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                maxLength: 1,
                type: "tel",
                "data-index": 3,
                value: otpValue[3],
                onFocus: handleOnFocus,
                onChange: handleOnChange,
                onKeyUp: handleOnInputPress
            })
        ]
    });
};
OTPInput.propTypes = {
    onSubmit: (prop_types_default()).func
};
/* harmony default export */ var otpinput = (OTPInput);

// EXTERNAL MODULE: ./hooks/useInterval.tsx
var useInterval = __webpack_require__(7438);
// EXTERNAL MODULE: ./components/LoginButtons/PhoneLogin/styles.module.scss
var PhoneLogin_styles_module = __webpack_require__(87207);
var PhoneLogin_styles_module_default = /*#__PURE__*/__webpack_require__.n(PhoneLogin_styles_module);
;// CONCATENATED MODULE: ./components/LoginButtons/PhoneLogin/index.tsx















var Steps;
(function(Steps) {
    Steps[Steps["error"] = 0] = "error";
    Steps[Steps["phoneInput"] = 1] = "phoneInput";
    Steps[Steps["OTPInput"] = 2] = "OTPInput";
})(Steps || (Steps = {}));
var AR_LOGO = "logos/NEW_LOGO_HORIZONTAL_AR.png";
var EN_LOGO = "new-anghami-logos/header-logo-fullblack.png";
function PhoneLogin(param) {
    var onModalChange = param.onModalChange, _onSuccess = param.onSuccess, onSuccess = _onSuccess === void 0 ? function(res) {
        return res;
    } : _onSuccess, _onError = param.onError, onError = _onError === void 0 ? function(error) {
        return error;
    } : _onError, _telcos = param.telcos, telcos = _telcos === void 0 ? null : _telcos;
    var ref = (0,react.useState)(null), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(telcos.telcos[0]), selectedTel = ref1[0], setSelectedTel = ref1[1];
    var ref2 = (0,react.useState)(false), showPopup = ref2[0], setShowPopup = ref2[1];
    var ref3 = (0,react.useState)(""), phoneNumber = ref3[0], setPhoneNumber = ref3[1];
    var ref4 = (0,react.useState)(null), error = ref4[0], setError = ref4[1];
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var ref6 = (0,react.useState)(0), retryTime = ref6[0], setRetryTime = ref6[1];
    var ref7 = (0,react.useState)(1), attemptsCount = ref7[0], setAttemptsCount = ref7[1];
    var ref8 = (0,esm/* useTranslation */.$G)(), t = ref8.t, _i18n = ref8.i18n, lang = _i18n.language;
    (0,useInterval/* default */.Z)(function() {
        if (retryTime > 0) {
            setRetryTime(retryTime - 1);
        }
    }, 1000);
    var renderStep = null;
    var handleTelChange = function(e) {
        var tel = telcos.telcos.find(function(tel) {
            return e.target.value === tel.planid;
        });
        setSelectedTel(tel);
    };
    var handlePhoneSubmit = function(e) {
        var retryCall = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        e.preventDefault();
        if (phoneNumber.length < 3) {
            setError({
                message: ""
            });
            return;
        }
        if (retryTime !== 0) {
            return;
        }
        (0,analytics/* default */.ZP)(events/* AmplitudeEvents.submitPhone */.X.submitPhone, {});
        setLoading(true);
        neogateway/* gateway.callEndpoint */.Y0.callEndpoint(postMsisdnLogin/* default */.Z, {
            telco: selectedTel.returnname,
            msisdn: Number(selectedTel.prefix + phoneNumber),
            call: retryCall ? 1 : 0,
            attempts_count: attemptsCount
        }).then(function(param) {
            var res = param.data;
            setLoading(false);
            setRetryTime(60);
            if (res.error) {
                setError(res.error);
                return;
            }
            setStep(Steps.OTPInput);
        }).catch(function(_) {
            setLoading(false);
            setError({
                message: t("Oops, something went wrong, please refresh the page")
            });
        }).finally(function() {
            setAttemptsCount(attemptsCount + 1);
        });
    };
    var handleOTPChange = function(value) {
        if (value.length === 4) {
            // if the user filled all the 4 numbers
            (0,analytics/* default */.ZP)(events/* AmplitudeEvents.submitVeritifcationCode */.X.submitVeritifcationCode, {
                code: value
            });
            setLoading(true);
            neogateway/* gateway.callEndpoint */.Y0.callEndpoint(postMsisdnAuthenticate/* default */.Z, {
                code: value,
                operator: selectedTel.returnname,
                msisdn: Number(selectedTel.prefix + phoneNumber)
            }).then(function(param) {
                var res = param.data;
                setLoading(false);
                if (res.error) {
                    setError(res.error);
                    return;
                }
                doAuthentication("an", (0,_object_spread/* default */.Z)({}, res.forcelogin)).then(function(param) {
                    var res = param.data;
                    setLoading(false);
                    setShowPopup(false);
                    onSuccess(res);
                    (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loggedInWithPhone */.X.loggedInWithPhone, {});
                    (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loginSuccessful */.X.loginSuccessful, {
                        method: "phone"
                    });
                }).catch(function(err) {
                    setError(error);
                    onError(err);
                    (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loginError */.X.loginError, {
                        method: "phone"
                    });
                });
            }).catch(function(error) {
                setLoading(false);
                setError(error);
                onError(error);
            });
        }
    };
    (0,react.useEffect)(function() {
        onModalChange(showPopup);
        if (step !== Steps.error && !showPopup) {
            setError(null);
        }
    }, [
        showPopup
    ]);
    switch(step){
        case Steps.phoneInput:
            renderStep = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((PhoneLogin_styles_module_default())["PhoneLogin-number"], " ").concat(error && "error"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (PhoneLogin_styles_module_default())["PhoneLogin-number-country"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                        className: (PhoneLogin_styles_module_default())["PhoneLogin-number-country-selector"],
                                        onChange: handleTelChange,
                                        children: telcos.telcos.map(function(tel) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: tel.planid,
                                                children: tel.operatorname
                                            }, tel.planid);
                                        })
                                    }),
                                    selectedTel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (PhoneLogin_styles_module_default())["PhoneLogin-number-country-code"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: selectedTel.image,
                                                alt: selectedTel.operatorname
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "+",
                                                    selectedTel.prefix
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                className: (PhoneLogin_styles_module_default())["PhoneLogin-number-form"],
                                onSubmit: handlePhoneSubmit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    required: true,
                                    autoFocus: true,
                                    className: (PhoneLogin_styles_module_default())["PhoneLogin-number-form-input"],
                                    type: "number",
                                    placeholder: t("Please enter your mobile number"),
                                    value: phoneNumber,
                                    onChange: function(e) {
                                        setError(null);
                                        setPhoneNumber(e.target.value);
                                    }
                                })
                            })
                        ]
                    }),
                    (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (PhoneLogin_styles_module_default())["PhoneLogin-number-error-message"],
                        children: error.message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
                        isLoading: loading,
                        className: (PhoneLogin_styles_module_default())["PhoneLogin-popup-btn"],
                        onClick: handlePhoneSubmit,
                        children: t("Continue")
                    })
                ]
            });
            break;
        case Steps.OTPInput:
            renderStep = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PhoneLogin_styles_module_default())["PhoneLogin-otp"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (PhoneLogin_styles_module_default())["PhoneLogin-otp-title"],
                        children: t("Verify your phone number")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (PhoneLogin_styles_module_default())["PhoneLogin-otp-subtitle"],
                        children: t("You will receive an SMS to your phone shortly")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(otpinput, {
                        onSubmit: handleOTPChange
                    }),
                    (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (PhoneLogin_styles_module_default())["PhoneLogin-number-error-message"],
                        children: error.message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (PhoneLogin_styles_module_default())["PhoneLogin-otp-subtitle"],
                        children: [
                            t("Didn't receive the code yet?"),
                            " ",
                            retryTime !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    t("Retry in"),
                                    " ",
                                    retryTime
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PhoneLogin_styles_module_default())["PhoneLogin-otp-btns"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "".concat((PhoneLogin_styles_module_default())["PhoneLogin-otp-btns-btn"], " ").concat(retryTime !== 0 && (PhoneLogin_styles_module_default())["PhoneLogin-otp-btns-btn-disabled"]),
                                onClick: function(e) {
                                    handlePhoneSubmit(e, false);
                                },
                                children: t("Resend")
                            }),
                            !telcos.hidecallme && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "".concat((PhoneLogin_styles_module_default())["PhoneLogin-otp-btns-btn"], " ").concat(retryTime !== 0 && (PhoneLogin_styles_module_default())["PhoneLogin-otp-btns-btn-disabled"]),
                                onClick: function(e) {
                                    handlePhoneSubmit(e, true);
                                },
                                children: t("Call me")
                            })
                        ]
                    })
                ]
            });
            break;
        case Steps.error:
            renderStep = (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (PhoneLogin_styles_module_default())["PhoneLogin-number-error-message"],
                children: error.message
            });
            break;
        default:
            renderStep = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Invalid step"
            });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PhoneLogin_styles_module_default()).PhoneLogin,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
                    icon: "phone",
                    className: (PhoneLogin_styles_module_default())["PhoneLogin-btn"],
                    onClick: function() {
                        (0,analytics/* default */.ZP)(events/* AmplitudeEvents.tapPhoneSignup */.X.tapPhoneSignup, {});
                        setShowPopup(true);
                        setStep(Steps.phoneInput);
                    },
                    children: t("Continue with phone number")
                })
            }),
            showPopup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PhoneLogin_styles_module_default())["PhoneLogin-popup"] + " animate-fadeIn",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (PhoneLogin_styles_module_default())["PhoneLogin-popup-logo"],
                                alt: "Anghami",
                                src: "".concat(environment.environment.web_cdn_url, "web/assets/img/").concat(lang === "ar" ? AR_LOGO : EN_LOGO)
                            }),
                            step !== Steps.OTPInput && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (PhoneLogin_styles_module_default())["PhoneLogin-popup-title"],
                                children: t("Login_now_web")
                            }),
                            renderStep,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (PhoneLogin_styles_module_default())["PhoneLogin-popup-back-btn"],
                                onClick: function() {
                                    setShowPopup(false);
                                },
                                children: t("back")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PhoneLogin_styles_module_default())["PhoneLogin-popup-overlay"],
                        onClick: function() {
                            setShowPopup(false);
                        }
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/getEmailExists.js
var getEmailExists = __webpack_require__(96539);
// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/registerUser.js
var registerUser = __webpack_require__(54272);
// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/postSendConfirmationEmail.js
var postSendConfirmationEmail = __webpack_require__(10077);
// EXTERNAL MODULE: ./components/LoginButtons/LocalLogin/styles.module.scss
var LocalLogin_styles_module = __webpack_require__(49178);
var LocalLogin_styles_module_default = /*#__PURE__*/__webpack_require__.n(LocalLogin_styles_module);
;// CONCATENATED MODULE: ./components/LoginButtons/LocalLogin/index.tsx
















var LocalLogin_Steps;
(function(Steps) {
    Steps[Steps["error"] = 0] = "error";
    Steps[Steps["loginDetailsInput"] = 1] = "loginDetailsInput";
    Steps[Steps["signupPasswordInputs"] = 2] = "signupPasswordInputs";
    Steps[Steps["signupAccountData"] = 3] = "signupAccountData";
    Steps[Steps["signupCheckYourEmail"] = 4] = "signupCheckYourEmail";
    Steps[Steps["loginDialog"] = 5] = "loginDialog";
})(LocalLogin_Steps || (LocalLogin_Steps = {}));
function LocalLogin(param) {
    var onModalChange = param.onModalChange, _onSuccess = param.onSuccess, onSuccess = _onSuccess === void 0 ? function() {
        return null;
    } : _onSuccess, _onError = param.onError, onError = _onError === void 0 ? function(error) {
        return error;
    } : _onError;
    var ref = (0,react.useState)(null), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(false), showPopup = ref1[0], setShowPopup = ref1[1];
    var ref2 = (0,react.useState)(""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(""), password = ref3[0], setPassword = ref3[1];
    var ref4 = (0,react.useState)(""), rePassword = ref4[0], setRePassword = ref4[1];
    var ref5 = (0,react.useState)(null), avatarFile = ref5[0], setAvatarFile = ref5[1];
    var ref6 = (0,react.useState)(""), fullname = ref6[0], setFullname = ref6[1];
    var ref7 = (0,react.useState)(""), birthday = ref7[0], setBirthday = ref7[1];
    var ref8 = (0,react.useState)(""), gender = ref8[0], setGender = ref8[1];
    var ref9 = (0,react.useState)(null), emailError = ref9[0], setEmailError = ref9[1];
    var ref10 = (0,react.useState)(null), passwordError = ref10[0], setPasswordError = ref10[1];
    var ref11 = (0,react.useState)(false), loading = ref11[0], setLoading = ref11[1];
    var ref12 = (0,esm/* useTranslation */.$G)(), t = ref12.t, _i18n = ref12.i18n, lang = _i18n.language;
    var ref13 = (0,react.useState)({}), inputsErrors = ref13[0], setInputsErrors = ref13[1];
    var ref14 = (0,react.useState)(null), dialog = ref14[0], setDialog = ref14[1];
    var ref15 = (0,react.useState)(""), message = ref15[0], setMessage = ref15[1];
    var renderStep = null;
    var handleEmailSubmit = function(e) {
        e.preventDefault();
        if (email.length < 3) {
            setEmailError({
                message: ""
            });
            return;
        }
        (0,analytics/* default */.ZP)(events/* AmplitudeEvents.tapEmailLogin */.X.tapEmailLogin, {});
        setLoading(true);
        neogateway/* gateway.callEndpoint */.Y0.callEndpoint(getEmailExists/* default */.Z, {
            email: email
        }, true).then(function(param) {
            var res = param.data;
            setLoading(false);
            if (res === null || res === void 0 ? void 0 : res.exists) {
                setShowPopup(true);
                setStep(LocalLogin_Steps.loginDetailsInput);
            } else {
                setShowPopup(true);
                setStep(LocalLogin_Steps.signupPasswordInputs);
            }
        }).catch(function(error) {
            setLoading(false);
            setEmailError(error);
        });
    };
    var handleDetailsSubmit = function(e) {
        e.preventDefault();
        if (email.length < 3) {
            setEmailError({
                message: ""
            });
            return;
        }
        if (password.length < 5 || password.length > 128) {
            setPasswordError({
                message: ""
            });
            return;
        }
        setLoading(true);
        doAuthentication("an", {
            email: email,
            password: password
        }).then(function(param) {
            var res = param.data;
            setLoading(false);
            if (res.error) {
                if (res.dialog) {
                    setDialog(res.dialog);
                    setStep(LocalLogin_Steps.loginDialog);
                    return;
                }
                setEmailError(res.error);
                return;
            }
            setShowPopup(false);
            onSuccess(res);
            (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loggedInWithemail */.X.loggedInWithemail, {});
            (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loginSuccessful */.X.loginSuccessful, {
                method: "email"
            });
        }).catch(function(e) {
            console.log("--Local login auth err", e);
            setLoading(false);
            onError(e);
            (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loginError */.X.loginError, {
                method: "email"
            });
        });
    };
    var handlePasswordsSubmit = function(e) {
        e.preventDefault();
        if (password.length === 0 || rePassword.length === 0) {
            setInputsErrors((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputsErrors), {
                password: true,
                rePassword: true
            }));
            return;
        }
        if (inputsErrors.password || inputsErrors.rePassword) {
            return;
        }
        setStep(LocalLogin_Steps.signupAccountData);
    };
    var getUserAvatar = function() {
        return avatarFile ? URL.createObjectURL(avatarFile) : "".concat(environment.environment.phoenix_url, "/adminupload/NoGender.jpeg");
    };
    var isGenderInvalid = function() {
        return gender.length < 1;
    };
    var handleUserInfoSubmit = function(e) {
        e.preventDefault();
        if (fullname.length === 0 || birthday.length === 0) {
            setInputsErrors((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputsErrors), {
                firstname: fullname.length === 0,
                birthday: birthday.length === 0
            }));
            return;
        }
        if (inputsErrors.fullname || inputsErrors.birthday) {
            return;
        }
        var age = new Date().getUTCFullYear() - new Date(birthday).getUTCFullYear();
        var params = {
            email: email,
            password: password,
            gender: gender,
            m: "an",
            firstname: fullname.split(" ")[0],
            lastname: fullname.split(" ")[1],
            age: age
        };
        setLoading(true);
        neogateway/* gateway.callEndpoint */.Y0.callEndpoint(registerUser/* registerUser */.a, params).then(function(param) {
            var res = param.data;
            if (res.error) {
                var ref, ref1, ref2;
                setLoading(false);
                setEmailError({
                    message: ((ref = res.error) === null || ref === void 0 ? void 0 : (ref1 = ref._attributes) === null || ref1 === void 0 ? void 0 : ref1.message) || (res === null || res === void 0 ? void 0 : (ref2 = res.error) === null || ref2 === void 0 ? void 0 : ref2.message)
                });
            } else {
                setLoading(false);
                setStep(LocalLogin_Steps.signupCheckYourEmail);
            }
        }).catch(function() {
            setLoading(false);
        });
    };
    var handleInputsChange = function(inputName) {
        switch(inputName){
            case "password":
                setInputsErrors((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputsErrors), {
                    password: password.length < 5 || password.length > 128
                }));
                break;
            case "rePassword":
                setInputsErrors((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputsErrors), {
                    rePassword: rePassword !== password
                }));
                break;
            case "fullname":
                setInputsErrors((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputsErrors), {
                    fullname: fullname.length < 2
                }));
                break;
            case "birthday":
                setInputsErrors((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputsErrors), {
                    birthday: birthday.length < 2
                }));
                break;
            default:
        }
    };
    var handleResetActivationEmail = function() {
        setLoading(true);
        neogateway/* gateway.callEndpoint */.Y0.callEndpoint(postSendConfirmationEmail/* default */.Z, {
            email: email
        }).then(function(param) {
            var res = param.data;
            setLoading(false);
            setMessage(res.message);
            setStep(LocalLogin_Steps.signupCheckYourEmail);
        }).catch(function() {
            setLoading(false);
        });
    };
    (0,react.useEffect)(function() {
        onModalChange(showPopup);
        setPassword("");
        setRePassword("");
    }, [
        showPopup
    ]);
    switch(step){
        case LocalLogin_Steps.loginDetailsInput:
            renderStep = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs"], " ").concat(emailError && "error"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-inputs-form"],
                        onSubmit: function(e) {
                            handleDetailsSubmit(e);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                required: true,
                                id: "local_login_email2",
                                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs-form-input"], " ").concat(emailError && "error"),
                                type: "email",
                                placeholder: t("enter your email"),
                                value: email,
                                onChange: function(e) {
                                    setEmailError(null);
                                    setEmail(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                required: true,
                                autoFocus: true,
                                id: "local_login_password",
                                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs-form-input"], " ").concat(passwordError && "error"),
                                type: "password",
                                placeholder: t("enter your password"),
                                value: password,
                                onChange: function(e) {
                                    setEmailError(null);
                                    setPasswordError(null);
                                    setPassword(e.target.value);
                                },
                                onKeyUp: function(_e) {
                                    if (_e.keyCode === 13) {
                                        handleDetailsSubmit(_e);
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "submit",
                                className: (LocalLogin_styles_module_default())["LocalLogin-inputs-form-input-hidden"]
                            })
                        ]
                    }),
                    (emailError === null || emailError === void 0 ? void 0 : emailError.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-inputs-error-message"],
                        children: emailError.message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
                        id: "local_login_submit2",
                        isLoading: loading,
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-btn"],
                        onClick: handleDetailsSubmit,
                        children: t("continue")
                    })
                ]
            });
            break;
        case LocalLogin_Steps.signupPasswordInputs:
            renderStep = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs"], " ").concat(emailError && "error"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-heading"],
                        children: t("Create a new account")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-title"],
                        children: email
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-inputs-form"],
                        onSubmit: handlePasswordsSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                required: true,
                                autoFocus: true,
                                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs-form-input"], " ").concat(inputsErrors.password && (LocalLogin_styles_module_default())["LocalLogin-inputs-form-input-error"]),
                                type: "password",
                                placeholder: t("enter your password"),
                                value: password,
                                onChange: function(e) {
                                    setPassword(e.target.value);
                                },
                                onBlur: function() {
                                    handleInputsChange("password");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                required: true,
                                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs-form-input"], " ").concat(inputsErrors.rePassword && (LocalLogin_styles_module_default())["LocalLogin-inputs-form-input-error"]),
                                type: "password",
                                placeholder: t("Confirm your password"),
                                value: rePassword,
                                onChange: function(e) {
                                    setRePassword(e.target.value);
                                },
                                onBlur: function() {
                                    handleInputsChange("rePassword");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "submit",
                                className: (LocalLogin_styles_module_default())["LocalLogin-inputs-form-input-hidden"]
                            })
                        ]
                    }),
                    (emailError === null || emailError === void 0 ? void 0 : emailError.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-inputs-error-message"],
                        children: emailError.message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
                        isLoading: loading,
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-btn"],
                        onClick: handlePasswordsSubmit,
                        children: t("Create a new account")
                    })
                ]
            });
            break;
        case LocalLogin_Steps.signupAccountData:
            renderStep = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs"], " ").concat(emailError && "error"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-heading"],
                        children: t("Complete your profile")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-inputs-form"],
                        onSubmit: handleUserInfoSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LocalLogin_styles_module_default())["LocalLogin-popup-avatar"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: getUserAvatar()
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: "avatar-file",
                                            type: "file",
                                            onChange: function(e) {
                                                setAvatarFile(e.target.files[0]);
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: (LocalLogin_styles_module_default())["LocalLogin-popup-label"],
                                children: t("Your full name")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                required: true,
                                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs-form-input"], " ").concat(inputsErrors.fullname && (LocalLogin_styles_module_default())["LocalLogin-inputs-form-input-error"]),
                                type: "text",
                                placeholder: t("Enter your full name"),
                                value: fullname,
                                onChange: function(e) {
                                    setFullname(e.target.value);
                                },
                                onBlur: function() {
                                    handleInputsChange("fullname");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: (LocalLogin_styles_module_default())["LocalLogin-popup-label"],
                                children: t("Your date of birth")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                required: true,
                                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs-form-input"], " ").concat(inputsErrors.birthday && (LocalLogin_styles_module_default())["LocalLogin-inputs-form-input-error"]),
                                type: "date",
                                value: birthday,
                                onChange: function(e) {
                                    setBirthday(e.target.value);
                                },
                                onBlur: function() {
                                    handleInputsChange("birthday");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-popup-radio-wrapper"], " ").concat(isGenderInvalid() && (LocalLogin_styles_module_default())["LocalLogin-inputs-form-input-error"]),
                                onChange: function(e) {
                                    setGender(e.target.value);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-label"],
                                        children: t("Gender")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        htmlFor: "male-radio",
                                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-radio"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                required: true,
                                                id: "male-radio",
                                                type: "radio",
                                                name: "gender",
                                                value: "male"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (LocalLogin_styles_module_default())["LocalLogin-popup-radio-custom"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("Male")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        htmlFor: "female-radio",
                                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-radio"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                required: true,
                                                id: "female-radio",
                                                type: "radio",
                                                name: "gender",
                                                value: "female"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (LocalLogin_styles_module_default())["LocalLogin-popup-radio-custom"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("Female")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "submit",
                                className: (LocalLogin_styles_module_default())["LocalLogin-inputs-form-input-hidden"]
                            })
                        ]
                    }),
                    (emailError === null || emailError === void 0 ? void 0 : emailError.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-inputs-error-message"],
                        children: emailError.message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
                        isLoading: loading,
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-btn"],
                        onClick: handleUserInfoSubmit,
                        children: t("Create a new account")
                    })
                ]
            });
            break;
        case LocalLogin_Steps.signupCheckYourEmail:
            renderStep = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (LocalLogin_styles_module_default())["LocalLogin-popup-title"],
                children: message || t("We sent you an email. Please check your inbox to validate your email.")
            });
            break;
        case LocalLogin_Steps.loginDialog:
            renderStep = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-heading"],
                        children: dialog.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-title"],
                        children: dialog.subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-btn"],
                        onClick: function() {
                            handleResetActivationEmail();
                        },
                        children: dialog.cancelbuttontext
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-btn-empty"],
                        onClick: function() {
                            setDialog(null);
                            setStep(LocalLogin_Steps.loginDetailsInput);
                        },
                        children: dialog.buttontext
                    })
                ]
            });
            break;
        default:
            renderStep = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Invalid step"
            });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LocalLogin_styles_module_default()).LocalLogin,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs"], " ").concat(emailError && "error"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                            className: (LocalLogin_styles_module_default())["LocalLogin-inputs-form"],
                            onSubmit: handleEmailSubmit,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                required: true,
                                autoFocus: true,
                                id: "local_login_email",
                                className: "".concat((LocalLogin_styles_module_default())["LocalLogin-inputs-form-input"], " ").concat(emailError && "error"),
                                type: "email",
                                placeholder: t("enter your email"),
                                value: email,
                                onChange: function(e) {
                                    setEmailError(null);
                                    setEmail(e.target.value);
                                }
                            })
                        })
                    }),
                    (emailError === null || emailError === void 0 ? void 0 : emailError.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-inputs-error-message"],
                        children: emailError.message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
                        id: "local_login_submit",
                        isLoading: loading,
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-btn"],
                        onClick: handleEmailSubmit,
                        children: t("continue")
                    })
                ]
            }),
            showPopup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup"] + " animate-fadeIn",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (LocalLogin_styles_module_default())["LocalLogin-popup-logo"],
                                alt: "Anghami",
                                src: "".concat(environment.environment.web_cdn_url, "web/assets/img/").concat(lang === "ar" ? "logos/NEW_LOGO_HORIZONTAL_AR.png" : "new-anghami-logos/header-logo-fullblack.png")
                            }),
                            renderStep,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (LocalLogin_styles_module_default())["LocalLogin-popup-back-btn"],
                                onClick: function() {
                                    setShowPopup(false);
                                },
                                children: t("back")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (LocalLogin_styles_module_default())["LocalLogin-popup-overlay"],
                        onClick: function() {
                            setShowPopup(false);
                        }
                    })
                ]
            })
        ]
    });
}
LocalLogin.propTypes = {
    onModalChange: (prop_types_default()).func,
    onSuccess: (prop_types_default()).func,
    onError: (prop_types_default()).func
};

// EXTERNAL MODULE: ../node_modules/react-qr-code/lib/index.js
var lib = __webpack_require__(88948);
// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/getDeviceCode.js
var getDeviceCode = __webpack_require__(8434);
// EXTERNAL MODULE: ./components/LoginButtons/QRLogin/styles.module.scss
var QRLogin_styles_module = __webpack_require__(22291);
var QRLogin_styles_module_default = /*#__PURE__*/__webpack_require__.n(QRLogin_styles_module);
;// CONCATENATED MODULE: ./components/LoginButtons/QRLogin/index.tsx














function QRLogin(param) {
    var onModalChange = param.onModalChange, _onSuccess = param.onSuccess, onSuccess = _onSuccess === void 0 ? function(res) {
        return res;
    } : _onSuccess, _onError = param.onError, onError = _onError === void 0 ? function(error) {
        return error;
    } : _onError;
    var ref = (0,react.useState)(false), showPopup = ref[0], setShowPopup = ref[1];
    var ref1 = (0,react.useState)(null), deviceCode = ref1[0], setDeviceCode = ref1[1];
    var ref2 = (0,react.useState)(false), loadingAuth = ref2[0], setLoadingAuth = ref2[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    (0,react.useEffect)(function() {
        return onModalChange(showPopup);
    }, [
        showPopup
    ]);
    (0,useInterval/* default */.Z)(function() {
        if (!showPopup) {
            return;
        }
        neogateway/* gateway.callEndpoint */.Y0.callEndpoint(getDeviceCode/* default */.Z, {
            udid: "",
            cacheBust: Date.now(),
            c: window.navigator.userAgent
        }).then(function(param) {
            var res = param.data;
            setDeviceCode(res);
            if (res.userid) {
                setLoadingAuth(true);
                doAuthentication("lc", {
                    userid: res.userid,
                    code: res.code
                }).then(function(param) {
                    var res = param.data;
                    setLoadingAuth(false);
                    setShowPopup(false);
                    onSuccess(res);
                    (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loggedInWithQRLogin */.X.loggedInWithQRLogin, {});
                    (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loginSuccessful */.X.loginSuccessful, {
                        method: "qrcode"
                    });
                }).catch(function(e) {
                    (0,analytics/* default */.ZP)(events/* AmplitudeEvents.loginError */.X.loginError, {
                        method: "qrcode"
                    });
                    onError(e);
                });
            }
        });
    }, 2000);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (QRLogin_styles_module_default()).QRLogin,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (QRLogin_styles_module_default())["QRLogin-img"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(environment.environment.new_web_cdn_url, "/web/assets/icons/all/QRCode.svg"),
                            alt: "qrcode"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (QRLogin_styles_module_default())["QRLogin-txt"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("login_code_text_first")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("login_code_text_second")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (QRLogin_styles_module_default())["QRLogin-btn"],
                        onClick: function() {
                            (0,analytics/* default */.ZP)(events/* AmplitudeEvents.tapQRLogin */.X.tapQRLogin, {});
                            setShowPopup(true);
                        },
                        children: t("login_code_button")
                    })
                ]
            }),
            showPopup && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (QRLogin_styles_module_default())["QRLogin-popup"] + " animate-fadeIn",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: (QRLogin_styles_module_default())["QRLogin-popup-logo"],
                                alt: "Anghami",
                                src: environment.environment.images_cdn_url + "/anghami-logo-black.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (QRLogin_styles_module_default())["QRLogin-popup-title"],
                                children: t("login_code_howto_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (QRLogin_styles_module_default())["QRLogin-popup-wrapper"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (QRLogin_styles_module_default())["QRLogin-popup-wrapper-help"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                            className: (QRLogin_styles_module_default())["QRLogin-popup-wrapper-help-list"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: t("login_code_howto_step1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: t("Connect devices steps")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: t("login_code_howto_step3")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (QRLogin_styles_module_default())["QRLogin-popup-wrapper-qr"],
                                        children: deviceCode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                                    value: "DEVICE_" + deviceCode.code,
                                                    size: 203,
                                                    level: "Q"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((QRLogin_styles_module_default())["QRLogin-popup-wrapper-qr-logo"], " ").concat(loadingAuth && (QRLogin_styles_module_default())["QRLogin-popup-wrapper-qr-logo-auth-loading"]),
                                                    children: loadingAuth ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RingLoading, {
                                                        isBlack: true
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: environment.environment.images_cdn_url + "/anghami-logo-black-notext.png",
                                                        alt: "anghami logo"
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (QRLogin_styles_module_default())["QRLogin-popup-wrapper-qr-loading"]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (QRLogin_styles_module_default())["QRLogin-popup-back-btn"],
                                onClick: function() {
                                    setShowPopup(false);
                                    setDeviceCode(null);
                                },
                                children: t("back")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (QRLogin_styles_module_default())["QRLogin-popup-overlay"],
                        onClick: function() {
                            setShowPopup(false);
                            setDeviceCode(null);
                        }
                    })
                ]
            })
        ]
    });
}
QRLogin.propTypes = {
    onModalChange: (prop_types_default()).func,
    onSuccess: (prop_types_default()).func,
    onError: (prop_types_default()).func
};

// EXTERNAL MODULE: ./components/LoginButtons/AppleLogin/styles.module.scss
var AppleLogin_styles_module = __webpack_require__(15408);
var AppleLogin_styles_module_default = /*#__PURE__*/__webpack_require__.n(AppleLogin_styles_module);
// EXTERNAL MODULE: ./enums/amplitude.ts
var amplitude = __webpack_require__(8719);
;// CONCATENATED MODULE: ./components/LoginButtons/AppleLogin/index.tsx










var AMPLITUDE_EVENTS = {
    LOGIN_SUCCESS: "Login successful",
    LOGIN_FAIL: "Login error"
};
function Apple(param) {
    var _onSuccess = param.onSuccess, onSuccess = _onSuccess === void 0 ? function(res) {
        return res;
    } : _onSuccess, _onError = param.onError, onError = _onError === void 0 ? function(error) {
        return error;
    } : _onError;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    var handleButtonClick = function() {
        (0,analytics/* default */.ZP)(amplitude/* AmplitudeEvents.tapAppleLogin */.X.tapAppleLogin, {});
        setLoading(true);
        loadAppleSDK().then(function() {
            handleAppleLogin().then(function(res) {
                var ref, ref1;
                doAuthentication("ap", {
                    identitytoken: (ref = res.detail) === null || ref === void 0 ? void 0 : ref.authorization.id_token,
                    authorizationcode: (ref1 = res.detail) === null || ref1 === void 0 ? void 0 : ref1.authorization.code
                }).then(function(param) {
                    var _$res = param.data;
                    setLoading(false);
                    onSuccess(_$res);
                    (0,analytics/* default */.ZP)(amplitude/* AmplitudeEvents.loggedInWithapple */.X.loggedInWithapple, {});
                    (0,analytics/* default */.ZP)(AMPLITUDE_EVENTS.LOGIN_SUCCESS, {
                        method: "apple"
                    });
                }).catch(function(error) {
                    setLoading(false);
                    onError(error);
                    (0,analytics/* default */.ZP)(AMPLITUDE_EVENTS.LOGIN_FAIL, {
                        method: "apple"
                    });
                });
            }).catch(function(error) {
                onError(error);
                setLoading(false);
            });
        }).catch(function() {
            setLoading(false);
            onError(null);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AppleLogin_styles_module_default()).AppleLogin,
        id: "apple-root",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
            icon: "apple",
            isLoading: loading,
            className: (AppleLogin_styles_module_default())["AppleLogin-btn"],
            onClick: handleButtonClick,
            children: t("Continue with Apple")
        })
    });
}
Apple.propTypes = {
    onSuccess: (prop_types_default()).func,
    onError: (prop_types_default()).func
};

// EXTERNAL MODULE: ./helpers/helper.ts + 1 modules
var helper = __webpack_require__(69232);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(86677);
// EXTERNAL MODULE: ./components/LoginButtons/LoginWithApp/styles.module.scss
var LoginWithApp_styles_module = __webpack_require__(76192);
var LoginWithApp_styles_module_default = /*#__PURE__*/__webpack_require__.n(LoginWithApp_styles_module);
// EXTERNAL MODULE: ./helpers/branch-helper.ts
var branch_helper = __webpack_require__(59633);
;// CONCATENATED MODULE: ./components/LoginButtons/LoginWithApp/index.tsx










function LoginWithApp(param) {
    var _redirectUrl = param.redirectUrl, redirectUrl = _redirectUrl === void 0 ? "" : _redirectUrl;
    var query = (0,router.useRouter)().query;
    var t = (0,esm/* useTranslation */.$G)().t;
    // show button only on phone and if redirectUrl is available
    if ((query === null || query === void 0 ? void 0 : query.redirecturl) && (query === null || query === void 0 ? void 0 : query.redirecturl_encoded) || redirectUrl) {
        var decodedUrl = atob((query === null || query === void 0 ? void 0 : query.redirecturl) || "");
        // checking for third party urls
        if (decodedUrl && !decodedUrl.includes("anghami.com") || redirectUrl && !redirectUrl.includes("anghami.com") || query.client_id === "alexa-skill") {
            return null;
        }
    }
    var handleButtonClick = function() {
        (0,analytics/* default */.ZP)(events/* AmplitudeEvents.continueInApp */.X.continueInApp, {});
        var currentPage = "anghami.com" + window.location.pathname + window.location.search;
        var loginWithAppURL = redirectUrl || atob((query === null || query === void 0 ? void 0 : query.redirecturl) || "") || currentPage;
        var cleanedUrl = loginWithAppURL.replace("https://", "").replace("http://", "").replace("www.", "");
        (0,branch_helper/* deeplinkIntoAppUsingBranch */.u)(cleanedUrl, false, "webview");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LoginWithApp_styles_module_default()).LoginWithApp,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GenericButton, {
            icon: "anghami",
            className: (LoginWithApp_styles_module_default())["LoginWithApp-btn"],
            onClick: handleButtonClick,
            children: t("Login with app")
        })
    });
}
LoginWithApp.propTypes = {
    redirectUrl: (prop_types_default()).string
};

// EXTERNAL MODULE: ../node_modules/@anghami/neogateway/dist/endpoints/getTelcos.js
var getTelcos = __webpack_require__(35783);
;// CONCATENATED MODULE: ./components/login-popup/index.tsx


















var Login = function(param) {
    var onAuth = param.onAuth, params = param.params, setHideModal = param.setHideModal, hideAppLogin = param.hideAppLogin, hidePhoneLogin = param.hidePhoneLogin;
    var ref;
    var ref1 = (0,react.useState)(true), hideSubModal = ref1[0], setHideSubModal = ref1[1];
    var ref2 = (0,react.useState)(null), telcos = ref2[0], setTelcos = ref2[1];
    var t = (0,esm/* useTranslation */.$G)().t;
    (0,react.useEffect)(function() {
        neogateway/* gateway.loadSodium */.Y0.loadSodium();
        neogateway/* gateway.callEndpoint */.Y0.callEndpoint(getTelcos/* default */.Z, params).then(function(param) {
            var data = param.data;
            setTelcos(data);
        }).catch(function() {
            setTelcos(null);
        });
        (0,analytics/* default */.ZP)(events/* AmplitudeEvents.viewLoginScreen */.X.viewLoginScreen, {});
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            hideSubModal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !hideAppLogin && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).loginwithapp,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginWithApp, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).divider
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (styles_module_default()).subtitle,
                                children: "Or"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleLogin, {
                        onSuccess: onAuth,
                        onError: console.log
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookLogin, {
                        onSuccess: onAuth,
                        onError: console.log
                    }),
                    !hidePhoneLogin && (telcos === null || telcos === void 0 ? void 0 : telcos.telcos) && (telcos === null || telcos === void 0 ? void 0 : (ref = telcos.telcos) === null || ref === void 0 ? void 0 : ref.length) !== 0 && // hide phone login if no telcos are available
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneLogin, {
                        telcos: telcos,
                        onModalChange: setHideModal,
                        onSuccess: onAuth,
                        onError: console.log
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        id: "popup_other_login_options",
                        className: (styles_module_default()).other_login_link,
                        onClick: function() {
                            setHideSubModal(false);
                            (0,analytics/* default */.ZP)(events/* AmplitudeEvents.moreLoginOptions */.X.moreLoginOptions, {});
                        },
                        children: t("Other login options")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Apple, {
                        onSuccess: onAuth,
                        onError: console.log
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).divider
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (styles_module_default()).or_continue_with_email,
                        children: t("or continue by email")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalLogin, {
                        onModalChange: setHideModal,
                        onSuccess: onAuth,
                        onError: console.log
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (styles_module_default())["back-btn"],
                        onClick: function() {
                            setHideSubModal(true);
                        },
                        children: t("back")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).divider
            }),
            !(0,helper/* isMobile */.tq)() && /*#__PURE__*/ (0,jsx_runtime.jsx)(QRLogin, {
                onModalChange: setHideModal,
                onSuccess: onAuth,
                onError: console.log
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).divider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (styles_module_default())["recaptcha-notice"],
                children: [
                    "This site is protected by reCAPTCHA and the Google",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: "https://policies.google.com/privacy",
                        children: "Privacy Policy"
                    }),
                    " ",
                    "and",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        rel: "noreferrer",
                        href: "https://policies.google.com/terms",
                        children: "Terms of Service"
                    }),
                    " ",
                    "apply."
                ]
            })
        ]
    });
};
var LoginPopup = function(param) {
    var params = param.params, _onClosePopUp = param.onClosePopUp, onClosePopUp = _onClosePopUp === void 0 ? function() {
        return null;
    } : _onClosePopUp, onAuth = param.onAuth;
    var ref = (0,react.useState)(false), hideModal = ref[0], setHideModal = ref[1];
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var lang = i18n.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "login_popup",
                className: "".concat((styles_module_default()).LoginPopup, " ").concat(hideModal && (styles_module_default()).hidden, " animate-fadeIn"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (styles_module_default()).logo,
                        alt: "Anghami",
                        src: "".concat(environment.environment.web_cdn_url, "web/assets/img/").concat(lang === "ar" ? "logos/NEW_LOGO_HORIZONTAL_AR.png" : "new-anghami-logos/header-logo-fullblack.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
                        params: params,
                        setHideModal: setHideModal,
                        onAuth: onAuth
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).overlay,
                onClick: function() {
                    return onClosePopUp();
                }
            })
        ]
    });
};
LoginPopup.propTypes = {
    params: (prop_types_default()).object,
    onClosePopUp: (prop_types_default()).func,
    onAuth: (prop_types_default()).func.isRequired
};
/* harmony default export */ var login_popup = (LoginPopup);


/***/ }),

/***/ 59633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ deeplinkIntoAppUsingBranch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59312);
/* harmony import */ var _anghami_neoanalytics_dist_sdks_branch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35768);



var _branch;
var getBranchDeepLink = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(pathname) {
        var isShort, deeplinkAction;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            isShort = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, deeplinkAction = _arguments.length > 2 ? _arguments[2] : void 0;
            if (!_branch) {
                _branch = new _anghami_neoanalytics_dist_sdks_branch__WEBPACK_IMPORTED_MODULE_0__/* .Branch */ .I();
            }
            return [
                2,
                _branch.getBranchLink(pathname, isShort, deeplinkAction)
            ];
        });
    });
    return function getBranchDeepLink(pathname) {
        return _ref.apply(this, arguments);
    };
}();
var deeplinkIntoAppUsingBranch = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(pathname) {
        var isShort, deeplinkAction, generatedLink, url;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isShort = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, deeplinkAction = _arguments.length > 2 ? _arguments[2] : void 0;
                    return [
                        4,
                        getBranchDeepLink(pathname, isShort, deeplinkAction)
                    ];
                case 1:
                    generatedLink = _state.sent();
                    url = new URL(generatedLink);
                    url.searchParams.delete("$ios_url");
                    url.searchParams.delete("$android_url");
                    url.searchParams.delete("$fallback_url");
                    console.log("Deeplinking to URL:", url.toString());
                    window.location.href = url.toString();
                    return [
                        2
                    ];
            }
        });
    });
    return function deeplinkIntoAppUsingBranch(pathname) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 7438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInterval; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);

function useInterval(callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var tick = function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        };
        if (delay) {
            var id = setInterval(function() {
                tick();
            }, delay);
            return function() {
                clearInterval(id);
            };
        }
    }, [
        delay
    ]);
}


/***/ }),

/***/ 15408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"styles_d-flex__RoLJ4","f-column":"styles_f-column__xeV63","f-justify-center":"styles_f-justify-center__BlqT6","f-justify-between":"styles_f-justify-between__ygbdI","f-justify-start":"styles_f-justify-start__g3Hbm","f-justify-end":"styles_f-justify-end__hfOfc","f-align-center":"styles_f-align-center__x_YU2","f-align-start":"styles_f-align-start__lyrdi","f-align-stretch":"styles_f-align-stretch__Tix16","f-align-end":"styles_f-align-end__SQwjY","f-center":"styles_f-center___J5m_","position-relative":"styles_position-relative__KZmcy","AppleLogin":"styles_AppleLogin__hrnfd","w-100":"styles_w-100__5qi2F","AppleLogin-btn":"styles_AppleLogin-btn__0kxIb"};

/***/ }),

/***/ 71564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"styles_d-flex__8NH0p","f-column":"styles_f-column__ubEE6","f-justify-center":"styles_f-justify-center__vYjCF","f-justify-between":"styles_f-justify-between__TsznK","f-justify-start":"styles_f-justify-start__Z8Vw_","f-justify-end":"styles_f-justify-end__SDjjg","f-align-center":"styles_f-align-center__L8r29","f-align-start":"styles_f-align-start__ppBAz","f-align-stretch":"styles_f-align-stretch__ciQ21","f-align-end":"styles_f-align-end__ENya9","f-center":"styles_f-center__6OmV2","position-relative":"styles_position-relative__oSgHr","w-100":"styles_w-100__yobeF","FacebookLogin":"styles_FacebookLogin__eod2p","FacebookLogin-btn":"styles_FacebookLogin-btn__xUQ5g"};

/***/ }),

/***/ 83066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"styles_d-flex__yaTnY","f-column":"styles_f-column__PF_pW","f-justify-center":"styles_f-justify-center__JTbcC","f-justify-between":"styles_f-justify-between__Tiklz","f-justify-start":"styles_f-justify-start__8vGuX","f-justify-end":"styles_f-justify-end__PjTMv","f-align-center":"styles_f-align-center__Yu3Qm","f-align-start":"styles_f-align-start__ywJNi","f-align-stretch":"styles_f-align-stretch__IHTPW","f-align-end":"styles_f-align-end__s_D6W","f-center":"styles_f-center__2WH_3","position-relative":"styles_position-relative__hOuex","w-100":"styles_w-100__VV5Qb","GenericButton":"styles_GenericButton__2Ket7","GenericButton-icon":"styles_GenericButton-icon__5jq2A"};

/***/ }),

/***/ 43084:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"styles_d-flex__JYELS","f-column":"styles_f-column__HKZ5O","f-justify-center":"styles_f-justify-center__kBIBr","f-justify-between":"styles_f-justify-between__ybe1e","f-justify-start":"styles_f-justify-start__hn6mC","f-justify-end":"styles_f-justify-end__BvebF","f-align-center":"styles_f-align-center__Pg7he","f-align-start":"styles_f-align-start__eGWG7","f-align-stretch":"styles_f-align-stretch__RHJWF","f-align-end":"styles_f-align-end__K1i0u","f-center":"styles_f-center__Jezq7","position-relative":"styles_position-relative__DQ7WM","GoogleLogin":"styles_GoogleLogin__ZnXso","w-100":"styles_w-100__lYgTP","GoogleLogin-btn":"styles_GoogleLogin-btn__3RevF","GoogleLogin-btn-loading":"styles_GoogleLogin-btn-loading__x9T7k"};

/***/ }),

/***/ 49178:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"styles_d-flex__GS_PU","f-column":"styles_f-column__Uytmn","f-justify-center":"styles_f-justify-center__CKY2W","f-justify-between":"styles_f-justify-between___8FRl","f-justify-start":"styles_f-justify-start__nQtNZ","f-justify-end":"styles_f-justify-end__mhIg8","f-align-center":"styles_f-align-center__ZF8Cn","f-align-start":"styles_f-align-start__tO_FB","f-align-stretch":"styles_f-align-stretch__pL39J","f-align-end":"styles_f-align-end__Ea3Fn","f-center":"styles_f-center__N7g7j","position-relative":"styles_position-relative__unspK","LocalLogin":"styles_LocalLogin__R4ItP","w-100":"styles_w-100__KSZHU","LocalLogin-btn":"styles_LocalLogin-btn__SJGkX","LocalLogin-text-btn":"styles_LocalLogin-text-btn__A7Q48","LocalLogin-inputs":"styles_LocalLogin-inputs__BTWqb","LocalLogin-inputs-form-input":"styles_LocalLogin-inputs-form-input__cu8ai","LocalLogin-inputs-form-input-error":"styles_LocalLogin-inputs-form-input-error__JdyBi","error":"styles_error__jUk5o","LocalLogin-inputs-form-input-date":"styles_LocalLogin-inputs-form-input-date__LfLHP","LocalLogin-inputs-form-input-hidden":"styles_LocalLogin-inputs-form-input-hidden__lp5Qk","LocalLogin-inputs-error-message":"styles_LocalLogin-inputs-error-message__Ilx13","LocalLogin-popup":"styles_LocalLogin-popup__c6pZd","LocalLogin-popup-overlay":"styles_LocalLogin-popup-overlay__wLcSr","LocalLogin-popup-logo":"styles_LocalLogin-popup-logo__U71Of","LocalLogin-popup-heading":"styles_LocalLogin-popup-heading__Suaaq","LocalLogin-popup-title":"styles_LocalLogin-popup-title__opZqm","LocalLogin-popup-btn":"styles_LocalLogin-popup-btn__5gRPc","LocalLogin-popup-btn-empty":"styles_LocalLogin-popup-btn-empty__XFCqP","LocalLogin-popup-back-btn":"styles_LocalLogin-popup-back-btn__Fyrx2","LocalLogin-popup-avatar":"styles_LocalLogin-popup-avatar__1pGIK","LocalLogin-popup-label":"styles_LocalLogin-popup-label__PnWDb","LocalLogin-popup-radio-wrapper":"styles_LocalLogin-popup-radio-wrapper__7e1wS","LocalLogin-popup-radio":"styles_LocalLogin-popup-radio__g2urh","LocalLogin-popup-radio-custom":"styles_LocalLogin-popup-radio-custom__TGc6i"};

/***/ }),

/***/ 76192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"styles_d-flex__zQ1Ux","f-column":"styles_f-column__85tBn","f-justify-center":"styles_f-justify-center__g3MVk","f-justify-between":"styles_f-justify-between__PraU_","f-justify-start":"styles_f-justify-start__SEuTb","f-justify-end":"styles_f-justify-end__Fhmae","f-align-center":"styles_f-align-center__wq5Dm","f-align-start":"styles_f-align-start__L_ikC","f-align-stretch":"styles_f-align-stretch__DPq82","f-align-end":"styles_f-align-end__9bqZK","f-center":"styles_f-center__Q3U73","position-relative":"styles_position-relative__EVHBv","LoginWithApp":"styles_LoginWithApp___wtcw","w-100":"styles_w-100__mR1JD","LoginWithApp-btn":"styles_LoginWithApp-btn__QfiPw"};

/***/ }),

/***/ 87207:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"styles_d-flex__AHhSM","f-column":"styles_f-column__ryLm5","f-justify-center":"styles_f-justify-center__rRPny","f-justify-between":"styles_f-justify-between__HGi4v","f-justify-start":"styles_f-justify-start__o73oa","f-justify-end":"styles_f-justify-end__bjIgn","f-align-center":"styles_f-align-center__ut4b3","f-align-start":"styles_f-align-start__7lSJ8","f-align-stretch":"styles_f-align-stretch__SUG3d","f-align-end":"styles_f-align-end__NlUwy","f-center":"styles_f-center__RO4bc","position-relative":"styles_position-relative__zCNKU","PhoneLogin":"styles_PhoneLogin__R6jwM","w-100":"styles_w-100__f_uHk","PhoneLogin-btn":"styles_PhoneLogin-btn__5_li2","PhoneLogin-number":"styles_PhoneLogin-number___EZVT","error":"styles_error__vn521","PhoneLogin-number-country":"styles_PhoneLogin-number-country__yqcwa","PhoneLogin-number-country-selector":"styles_PhoneLogin-number-country-selector___0vq8","PhoneLogin-number-country-code":"styles_PhoneLogin-number-country-code__61W2D","PhoneLogin-number-form":"styles_PhoneLogin-number-form__l5j_L","PhoneLogin-number-form-input":"styles_PhoneLogin-number-form-input__H69kh","PhoneLogin-number-error-message":"styles_PhoneLogin-number-error-message__PYORi","PhoneLogin-popup":"styles_PhoneLogin-popup__otIOa","PhoneLogin-popup-overlay":"styles_PhoneLogin-popup-overlay__nQV78","PhoneLogin-popup-logo":"styles_PhoneLogin-popup-logo__Kq63N","PhoneLogin-popup-title":"styles_PhoneLogin-popup-title__Z5ZT_","PhoneLogin-popup-btn":"styles_PhoneLogin-popup-btn__EAbfL","PhoneLogin-popup-back-btn":"styles_PhoneLogin-popup-back-btn__G9A7F","PhoneLogin-otp":"styles_PhoneLogin-otp__7ZNSx","PhoneLogin-otp-title":"styles_PhoneLogin-otp-title__BJaqW","PhoneLogin-otp-subtitle":"styles_PhoneLogin-otp-subtitle__lLHtl","PhoneLogin-otp-input":"styles_PhoneLogin-otp-input__X1h0z","PhoneLogin-otp-btns":"styles_PhoneLogin-otp-btns__KwiUO","PhoneLogin-otp-btns-btn":"styles_PhoneLogin-otp-btns-btn___qCnd","PhoneLogin-otp-btns-btn-disabled":"styles_PhoneLogin-otp-btns-btn-disabled__K1a2w"};

/***/ }),

/***/ 22291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"styles_d-flex__8gY9u","f-column":"styles_f-column___2heC","f-justify-center":"styles_f-justify-center__7Qe1s","f-justify-between":"styles_f-justify-between__dHYdq","f-justify-start":"styles_f-justify-start__YINpR","f-justify-end":"styles_f-justify-end__od82h","f-align-center":"styles_f-align-center__qloxQ","f-align-start":"styles_f-align-start___9Mpq","f-align-stretch":"styles_f-align-stretch__hypKS","f-align-end":"styles_f-align-end__53rEI","f-center":"styles_f-center__UHZ7j","position-relative":"styles_position-relative__Mr7F1","QRLogin":"styles_QRLogin__D2v5M","w-100":"styles_w-100__N08yu","QRLogin-img":"styles_QRLogin-img__BY_Ex","QRLogin-txt":"styles_QRLogin-txt__d68_9","QRLogin-btn":"styles_QRLogin-btn__MHRfa","QRLogin-popup":"styles_QRLogin-popup__HwcUb","QRLogin-popup-overlay":"styles_QRLogin-popup-overlay__FYS1_","QRLogin-popup-logo":"styles_QRLogin-popup-logo__lTQXj","QRLogin-popup-title":"styles_QRLogin-popup-title__kQdY_","QRLogin-popup-wrapper":"styles_QRLogin-popup-wrapper__Ou2ip","QRLogin-popup-wrapper-help":"styles_QRLogin-popup-wrapper-help__XeNVu","QRLogin-popup-wrapper-help-list":"styles_QRLogin-popup-wrapper-help-list__UvKoH","QRLogin-popup-wrapper-qr":"styles_QRLogin-popup-wrapper-qr__S5QMd","QRLogin-popup-wrapper-qr-logo":"styles_QRLogin-popup-wrapper-qr-logo__kNRg3","QRLogin-popup-wrapper-qr-logo-auth-loading":"styles_QRLogin-popup-wrapper-qr-logo-auth-loading__51ESm","QRLogin-popup-wrapper-qr-loading":"styles_QRLogin-popup-wrapper-qr-loading__v7RxA","placeholderShimmer":"styles_placeholderShimmer__pCKoN","QRLogin-popup-back-btn":"styles_QRLogin-popup-back-btn__0m9yp"};

/***/ }),

/***/ 56687:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"styles_d-flex__GIIsf","f-column":"styles_f-column__e9KCK","f-justify-center":"styles_f-justify-center__sEY2e","f-justify-between":"styles_f-justify-between__orJz8","f-justify-start":"styles_f-justify-start__NFwez","f-justify-end":"styles_f-justify-end__eEVO5","f-align-center":"styles_f-align-center__o__oZ","f-align-start":"styles_f-align-start__HRbo9","f-align-stretch":"styles_f-align-stretch__XtY5e","f-align-end":"styles_f-align-end__TQR4E","f-center":"styles_f-center__tagAz","position-relative":"styles_position-relative__vindL","w-100":"styles_w-100__vo8oh","RingLoading":"styles_RingLoading__FPH3E","lds-ring":"styles_lds-ring__k6DYd","RingLoading-black":"styles_RingLoading-black__NPM5_"};

/***/ }),

/***/ 75359:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"styles_d-flex__YEhc0","f-column":"styles_f-column__kaOOr","f-justify-center":"styles_f-justify-center__5dbaA","f-justify-between":"styles_f-justify-between__4D6XZ","f-justify-start":"styles_f-justify-start___Ct5y","f-justify-end":"styles_f-justify-end__dbWky","f-align-center":"styles_f-align-center__QoYzH","f-align-start":"styles_f-align-start__71wql","f-align-stretch":"styles_f-align-stretch__a8jza","f-align-end":"styles_f-align-end__ni58x","f-center":"styles_f-center__tA3L7","position-relative":"styles_position-relative__3NlsJ","w-100":"styles_w-100__ZcKIv","LoginPopup":"styles_LoginPopup__XoY2r","hidden":"styles_hidden__rs96b","overlay":"styles_overlay__sS_eQ","logo":"styles_logo__JIP3L","title":"styles_title__t4JoM","loginwithapp":"styles_loginwithapp__xmMKm","subtitle":"styles_subtitle__HpwIT","or_continue_with_email":"styles_or_continue_with_email__dPyqr","other_login_link":"styles_other_login_link__4NVZ0","back-btn":"styles_back-btn__sYZmL","divider":"styles_divider__pGtPL","recaptcha-notice":"styles_recaptcha-notice__qvdEW"};

/***/ }),

/***/ 8199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"otpinput_d-flex__F9vu4","f-column":"otpinput_f-column__18iFP","f-justify-center":"otpinput_f-justify-center__ntbQM","f-justify-between":"otpinput_f-justify-between__sY1dQ","f-justify-start":"otpinput_f-justify-start___vB_a","f-justify-end":"otpinput_f-justify-end__YEDuZ","f-align-center":"otpinput_f-align-center__EpKjP","f-align-start":"otpinput_f-align-start__AIBUr","f-align-stretch":"otpinput_f-align-stretch__X1ElX","f-align-end":"otpinput_f-align-end__vj28X","f-center":"otpinput_f-center__WEaOf","position-relative":"otpinput_position-relative__7ilLY","w-100":"otpinput_w-100__v3OIQ","OTPInput":"otpinput_OTPInput__cn3iV"};

/***/ })

}]);